// src/pages/Login.js

import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import qs from "qs";
import { jwtDecode } from "jwt-decode";
import ResendRegistrationLinkBanner from "../components/ResendRegistrationLinkBanner";

const Login = ({ onLogin }) => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorCode, setErrorCode] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setErrorCode(null);
    setSubmitting(true);

    try {
      const response = await axios.post(
        "https://ghrianghraffy.com/auth/login",
        qs.stringify({ username: identifier, password }),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );

      // If backend ever returns redirect_to (not currently), honor it
      if (response.data.redirect_to) {
        navigate(response.data.redirect_to);
        return;
      }

      const token = response.data.access_token;
      const refresh = response.data.refresh_token;
      if (!token) throw new Error("Login succeeded but no token returned.");

      localStorage.setItem("token", token);
      if (refresh) localStorage.setItem("refreshToken", refresh);

      const decoded = jwtDecode(token);
      onLogin?.(token);

      switch (decoded?.role) {
      case "ADMIN":
        navigate("/admin", { replace: true });
        break;
      case "PRINCIPAL":
        navigate("/principal-dashboard", { replace: true });
        break;
      case "STAFF":
        navigate("/staff-dashboard", { replace: true });
        break;
      case "PARENT":
      default:
        navigate("/view-photos", { replace: true });
        break;
      }
    } catch (error) {
      let msg = "Invalid username or password. Please try again.";
      let code = null;
      const data = error?.response?.data;

      if (data?.detail?.message) {
        msg = data.detail.message;
        code = data.detail.error_code || null;
      } else if (typeof data?.detail === "string") {
        msg = data.detail;
      }

      setErrorMessage(msg);
      setErrorCode(code);
      console.error("Login failed:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container page">
      <div className="login-card">
        <header className="login-header">
          <h1 className="login-title">Login</h1>
          <p className="login-subtitle">
            Sign in with your GhrianGhraffy account to manage and share your
            school&apos;s photos.
          </p>
        </header>

        {errorMessage && (
          <p className="error-message" aria-live="polite">
            {errorMessage}
          </p>
        )}

        <form onSubmit={handleLogin} className="login-form">
          <div className="login-field-group">
            <label htmlFor="login-email" className="login-label">
              Email
            </label>
            <input
              id="login-email"
              type="email"
              className="login-input"
              placeholder="you@school.ie"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
            />
          </div>

          <div className="login-field-group">
            <label htmlFor="login-password" className="login-label">
              Password
            </label>
            <input
              id="login-password"
              type="password"
              className="login-input"
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-btn" disabled={submitting}>
            {submitting ? "Signing in…" : "Login"}
          </button>
        </form>

        <p className="login-links">
          <a className="template-download-link login-forgot-link" href="/forgot-password">
            Forgot your password?
          </a>
        </p>

        {/* If account isn’t complete yet, show resend CTA */}
        {errorCode === "INCOMPLETE_SETUP" && identifier && (
          <div className="login-resend-banner-wrap">
            <ResendRegistrationLinkBanner email={identifier} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
